import React, { useState, useRef } from 'react';
import { reactionsConfig, defaultLikeIcon } from './reactionsConfig';

const ReactionButton = ({ onLike, onSelectReaction, currentUserLike }) => {
  const [showReactions, setShowReactions] = useState(false);
  const [isHoveringButton, setIsHoveringButton] = useState(false);
  const [isHoveringReactionsPopup, setIsHoveringReactionsPopup] = useState(false);
  const hideTimer = useRef(null);

  const showReactionsPopup = () => {
    if (hideTimer.current) clearTimeout(hideTimer.current);
    setShowReactions(true);
  };

  const hideReactionsPopup = () => {
    hideTimer.current = setTimeout(() => {
      setShowReactions(false);
    }, 200); // Pequeño retraso para permitir el movimiento del ratón
  };

  const handleMouseEnterButton = () => {
    setIsHoveringButton(true);
    showReactionsPopup();
  };

  const handleMouseLeaveButton = () => {
    setIsHoveringButton(false);
    if (!isHoveringReactionsPopup) {
      hideReactionsPopup();
    }
  };

  const handleMouseEnterPopup = () => {
    setIsHoveringReactionsPopup(true);
    showReactionsPopup(); // Asegurarse de que no se cierre si ya estaba abierto
  };

  const handleMouseLeavePopup = () => {
    setIsHoveringReactionsPopup(false);
    if (!isHoveringButton) {
      hideReactionsPopup();
    }
  };

  const handleReactionSelect = (reactionType) => {
    onSelectReaction(reactionType);
    setShowReactions(false);
    if (hideTimer.current) clearTimeout(hideTimer.current);
  };

  const currentReaction = currentUserLike
    ? reactionsConfig[currentUserLike.type]
    : null;

  return (
    <div
      className="relative"
      onMouseEnter={handleMouseEnterButton}
      onMouseLeave={handleMouseLeaveButton}
    >
      {/* Reactions Popup */}
      {showReactions && (
        <div
          className="absolute bottom-full mb-2 flex space-x-2 bg-white dark:bg-gray-800 p-2 rounded-full shadow-lg z-10 border border-gray-200 dark:border-gray-700"
          onMouseEnter={handleMouseEnterPopup}
          onMouseLeave={handleMouseLeavePopup}
        >
          {Object.entries(reactionsConfig).map(([key, reaction]) => (
            <button
              key={key}
              onClick={() => handleReactionSelect(key)}
              className="text-2xl transform transition-transform hover:scale-125"
              title={reaction.name}
            >
              {reaction.icon}
            </button>
          ))}
        </div>
      )}

      {/* Main Button */}
      <button
        onClick={onLike}
        className={`px-2 py-2 rounded-lg text-center font-semibold transition-colors w-full flex items-center justify-center ${
          currentReaction
            ? 'text-blue-600' // Or use reaction.color
            : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
        }`}
      >
        {currentReaction ? (
          <>
            <span className="text-xl mr-1">{currentReaction.icon}</span>
            <span>{currentReaction.name}</span>
          </>
        ) : (
          <><i className={`fas ${defaultLikeIcon} mr-2`}></i> Me gusta</>
        )}
      </button>
    </div>
  );
};

export default ReactionButton;